/**
 * Internal dependencies
 */
import { getQueryArg } from '../url';
import { getCookie, setCookie } from '../cookies';

export function isStagingSimulated(): boolean {
	if ( undefined !== getQueryArg( window.location.href, 'nabstaging' ) ) {
		setCookie( 'nabSimulateStaging', 'true' );
	}
	return undefined !== getCookie( 'nabSimulateStaging' );
}
